const Expander = {
  init(element = document) {
    this.triggers = Array.from(element.querySelectorAll('[data-expand]'));

    this.triggers.forEach((trigger) => {
      trigger.addEventListener('click', this.handleExpander);
    });
  },

  handleExpander(ev) {
    ev.preventDefault();

    const target = document.querySelector(ev.currentTarget.dataset.expand);

    if (target) {
      target.classList.toggle('is-expanded');
    }
  },
};

export default Expander;
